import { RouterProvider } from '@tanstack/react-router'
import { useQueryClient } from '@tanstack/react-query'
import { AuthProvider } from '@/providers/auth-provider'
import { AppShellSkeleton } from '@/components/app-shell-skeleton'
import { SessionChangedModal } from '@/components/session-changed-modal'
import { useAuth } from '@/hooks/use-auth'
import { router } from './router'

function AuthedApp() {
  const auth = useAuth()
  const queryClient = useQueryClient()

  if (auth.isLoading) {
    return <AppShellSkeleton />
  }

  return <RouterProvider router={router} context={{ auth, queryClient }} />
}

function App() {
  return (
    <AuthProvider>
      <AuthedApp />
      {/* Rendered at root so the SDK response interceptor can open it from */}
      {/* any call site, including before RouterProvider mounts (SUP-3373). */}
      <SessionChangedModal />
    </AuthProvider>
  )
}

export default App
